/**
 * Costanti di polling / timeout / refetch usate trasversalmente nella PWA.
 *
 * Convenzione: SUFFISSO _MS perche' i timer JS lavorano in millisecondi
 * (setInterval, setTimeout, React Query refetchInterval). Per le durate
 * espresse in secondi (es. timeout chiamate API), suffisso _S.
 *
 * Estratte qui per evitare magic numbers sparpagliati nei componenti.
 * Cambi globali (es. ridurre il polling per risparmiare batteria) si fanno
 * in un unico posto.
 */

// ============================================================================
// Refetch intervals (React Query)
// ============================================================================

/** Selettiva GPS mappa: 5s = aggiornamento posizioni quasi real-time durante intervento. */
export const REFETCH_GPS_MAP_MS = 5_000;
/** Lista utenti che hanno risposto a una selettiva: 10s. */
export const REFETCH_RESPONSES_MS = 10_000;
/** Liste pesanti (selettive attive, dashboard summary, SAR): 15s. */
export const REFETCH_LIST_MS = 15_000;
/** Dashboard layout (leaderboard, scadenze etc.): 30s. */
export const REFETCH_DASHBOARD_MS = 30_000;
/** Leaderboard interventi: 60s (cambia raramente). */
export const REFETCH_LEADERBOARD_MS = 60_000;

// ============================================================================
// Timeout / setTimeout
// ============================================================================

/** Toast/notifica auto-hide (es. ExpiryAlerts). */
export const TOAST_HIDE_MS = 15_000;
/** Redirect dopo registrazione riuscita. */
export const REGISTER_REDIRECT_MS = 3_500;
/** Cleanup di Blob URL dopo download. */
export const BLOB_REVOKE_MS = 500;
/** Cleanup di Blob URL piu' lungo (esports che possono essere riaperti). */
export const BLOB_REVOKE_LONG_MS = 60_000;
/** Timeout pratico per navigator.geolocation.getCurrentPosition. */
export const GEO_TIMEOUT_MS = 5_000;
/** Timeout esteso per getCurrentPosition quando serve high accuracy. */
export const GEO_TIMEOUT_HIGH_ACCURACY_MS = 8_000;
